import { getDaysInMonth, getYear, setMonth } from 'date-fns';
import moment, { type Moment } from 'moment';
import { useTranslation } from 'react-i18next';
import variables from 'common/styles/variables.json';
import { Col, Row, Select, InputNumber } from 'ui';

export type BirthDateType = {
  day: number;
  month: number;
  year: number;
  date: Moment;
  isNumberOfDaysValid?: boolean;
};

type P = {
  value?: Partial<BirthDateType>;
  onChange?: (value: Partial<BirthDateType>) => void;
};

const BirthDatePicker = ({ value, onChange }: P) => {
  const { t } = useTranslation();

  const makeMonthOptions = () => {
    const options = [];
    const date = new Date();

    for (let index = 0; index < 12; index += 1) {
      const then = setMonth(date, index);
      options.push({
        value: index,
        label: t('dateFormatMonth', { date: new Date(then) }),
      });
    }

    return options;
  };

  const onChangeDate = ({ day, month, year }: Partial<BirthDateType>) => {
    const selectedDay = day ?? value?.day;
    const selectedMonth = month ?? value?.month;
    const selectedYear = year ?? value?.year;

    const daysInMonth =
      selectedYear !== undefined && selectedMonth !== undefined
        ? getDaysInMonth(new Date(selectedYear, selectedMonth))
        : undefined;

    const isNumberOfDaysValid = daysInMonth !== undefined && selectedDay !== undefined && daysInMonth >= selectedDay;

    return onChange?.({
      day: selectedDay,
      month: selectedMonth,
      year: selectedYear,
      date:
        selectedDay !== undefined && selectedMonth !== undefined && selectedYear !== undefined && isNumberOfDaysValid
          ? moment(new Date(selectedYear, selectedMonth, selectedDay, 12, 0))
          : undefined,
      isNumberOfDaysValid,
    });
  };

  return (
    <Row item={{ gutter: [variables.spaceXs.value, variables.spaceXs.value], className: 'birth-date-picker' }}>
      <Col item={{ span: 13 }}>
        <Select
          options={makeMonthOptions()}
          value={value?.month}
          placeholder={t('Month')}
          onChange={(selectedValue) => onChangeDate({ month: Number(selectedValue) })}
        />
      </Col>
      <Col item={{ span: 5 }}>
        <InputNumber
          placeholder="DD"
          className="birth-date-picker__input"
          value={value?.day}
          min={1}
          max={31}
          onChange={(selectedValue) => onChangeDate({ day: Number(selectedValue) })}
        />
      </Col>
      <Col item={{ span: 6 }}>
        <InputNumber
          placeholder="YYYY"
          className="birth-date-picker__input"
          value={value?.year}
          min={1}
          max={getYear(new Date())}
          onChange={(selectedValue) => onChangeDate({ year: Number(selectedValue) })}
        />
      </Col>
    </Row>
  );
};

export default BirthDatePicker;
